import type { MediaItem } from "@/types/media";

export const tvShows: MediaItem[] = [
  {
    id: "tv-01",
    type: "tv",
    title: "长安十二时",
    year: 2026,
    region: "中国",
    genres: ["历史", "悬疑"],
    rating: 9.0,
    popularity: 13420,
    director: "张若尘",
    cast: ["雷云生", "易清月", "徐子谦", "霍云川"],
    duration: "全 48 集",
    cover: "https://readdy.ai/api/search-image?query=an%20ancient%20chinese%20city%20at%20night%20with%20glowing%20lanterns%20and%20a%20guarded%20figure%20in%20hanfu%2C%20epic%20historical%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20ancient%20chinese%20capital%20city%20at%20dusk%20with%20temples%20and%20glowing%20lanterns%20and%20mist%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-01-bd&orientation=landscape",
    summary: "二十四小时之内，一场足以颠覆王朝的阴谋。",
    synopsis: "上元灯节前夕，长安城暗流涌动。一位身负隐秘使命的少尹在十二个时辰内追查一场威胁皇城的阴谋。权谋、忠义与人性在繁华的长安城里交织，每一步都牵动生死。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20ancient%20chinese%20palace%20corridor%20lit%20by%20lanterns%20at%20night%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20an%20ancient%20market%20street%20with%20lanterns%20and%20crowds%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20night%20rooftop%20scene%20over%20an%20ancient%20city%20with%20moonlight%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-03&orientation=landscape",
    ],
    tags: ["古装", "权谋", "大制作"],
    updatedAt: "2026-10-13",
  },
  {
    id: "tv-02",
    type: "tv",
    title: "都市浮沉",
    year: 2025,
    region: "中国",
    genres: ["都市", "剧情"],
    rating: 8.4,
    popularity: 10120,
    director: "李文清",
    cast: ["顾明轩", "苏珊", "周牧云"],
    duration: "全 36 集",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20professional%20standing%20before%20a%20glowing%20skyscraper%20window%20at%20night%20overlooking%20a%20city%2C%20modern%20urban%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20modern%20city%20skyline%20at%20blue%20hour%20with%20glowing%20office%20windows%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-02-bd&orientation=landscape",
    summary: "三个年轻人，在这座城市里浮浮沉沉。",
    synopsis: "出身不同的三个年轻人在同一家创业公司相遇，在理想与现实的碰撞中，他们经历了事业的高光与低谷、友情与爱情的考验。这是一部关于奋斗、选择与成长的都市群像剧。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20modern%20office%20meeting%20room%20with%20glass%20walls%20and%20city%20view%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-04&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20friends%20talking%20on%20a%20city%20rooftop%20at%20dusk%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-05&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20rainy%20city%20street%20with%20umbrellas%20and%20glowing%20shops%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-06&orientation=landscape",
    ],
    tags: ["职场", "成长", "群像"],
    updatedAt: "2026-10-11",
  },
  {
    id: "tv-03",
    type: "tv",
    title: "暗夜行者",
    year: 2026,
    region: "中国",
    genres: ["犯罪", "悬疑"],
    rating: 8.6,
    popularity: 11480,
    director: "陈默",
    cast: ["秦烈", "温小雨", "程安"],
    duration: "全 40 集",
    cover: "https://readdy.ai/api/search-image?query=a%20lone%20figure%20in%20a%20hooded%20jacket%20walking%20through%20a%20dark%20rainy%20alley%20with%20glowing%20signs%2C%20crime%20thriller%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20dark%20city%20back%20alley%20at%20night%20with%20wet%20reflections%20and%20neon%20signs%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-03-bd&orientation=landscape",
    summary: "白天是普通职员，夜晚是追索真相的暗夜行者。",
    synopsis: "一场意外让普通人程野失去至亲，为了查明真相，他选择在夜晚以另一种身份潜入城市的地下世界。随着线索逐渐拼合，他发现真相远比想象中更复杂，也更危险。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20underground%20parking%20garage%20with%20dim%20lights%20and%20a%20lone%20car%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-07&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20evidence%20photos%20and%20a%20laptop%20on%20a%20dim%20desk%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-08&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20night%20bridge%20scene%20with%20city%20lights%20and%20a%20lone%20figure%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-09&orientation=landscape",
    ],
    tags: ["悬疑", "犯罪", "反转"],
    updatedAt: "2026-10-12",
  },
  {
    id: "tv-04",
    type: "tv",
    title: "星辰大海",
    year: 2026,
    region: "中国",
    genres: ["科幻", "剧情"],
    rating: 8.8,
    popularity: 12030,
    director: "罗宇",
    cast: ["沈星河", "白露", "江远航"],
    duration: "全 44 集",
    cover: "https://readdy.ai/api/search-image?query=a%20futuristic%20space%20station%20orbiting%20a%20glowing%20blue%20planet%20with%20a%20lone%20figure%20silhouette%2C%20epic%20sci%20fi%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20space%20station%20interior%20with%20holographic%20displays%20and%20a%20giant%20window%20showing%20a%20blue%20planet%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-04-bd&orientation=landscape",
    summary: "人类驶向星辰大海的百年征程。",
    synopsis: "在人类启动星际殖民计划的第十年，一支驻守在空间站的年轻团队接到了来自深空的未知信号。面对孤独、危险与未知，他们用青春和信念书写着属于这个时代的星际史诗。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20futuristic%20space%20station%20corridor%20with%20blue%20lights%20and%20crew%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-10&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20an%20astronaut%20looking%20at%20a%20vast%20star%20field%20through%20a%20window%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-11&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20space%20walk%20scene%20above%20an%20orbiting%20space%20station%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-12&orientation=landscape",
    ],
    tags: ["科幻", "星际", "热血"],
    updatedAt: "2026-10-09",
  },
  {
    id: "tv-05",
    type: "tv",
    title: "医心仁术",
    year: 2025,
    region: "中国",
    genres: ["职场", "剧情"],
    rating: 8.0,
    popularity: 8620,
    director: "何静",
    cast: ["林尚文", "叶知夏", "方主任"],
    duration: "全 38 集",
    cover: "https://readdy.ai/api/search-image?query=a%20young%20doctor%20in%20a%20white%20coat%20standing%20in%20a%20bright%20hospital%20corridor%20with%20soft%20light%2C%20medical%20drama%20cinematic%20lighting%2C%20clean%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20modern%20hospital%20corridor%20with%20soft%20daylight%20and%20medical%20staff%2C%20clean%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-05-bd&orientation=landscape",
    summary: "在生死之间，医者仁心从不曾缺席。",
    synopsis: "一位年轻外科医生进入顶尖医院后，面对的不仅是高难度的手术，还有复杂的人情与抉择。在与病痛、误解和自我的较量中，他逐渐成长为一名真正的医者。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20operation%20room%20scene%20with%20focused%20surgeons%20and%20bright%20lights%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-13&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20doctor%20talking%20with%20a%20patient%20family%20in%20a%20soft%20lit%20ward%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-14&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20hospital%20rooftop%20scene%20at%20dusk%20with%20a%20lone%20doctor%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-15&orientation=landscape",
    ],
    tags: ["医疗", "感动", "职业"],
    updatedAt: "2026-10-02",
  },
  {
    id: "tv-06",
    type: "tv",
    title: "灵界秘闻",
    year: 2026,
    region: "日本",
    genres: ["奇幻", "悬疑"],
    rating: 8.2,
    popularity: 7930,
    director: "佐藤健太",
    cast: ["山田凉介", "新垣结衣代", "木村拓真"],
    duration: "全 24 集",
    cover: "https://readdy.ai/api/search-image?query=a%20mysterious%20silhouette%20surrounded%20by%20glowing%20blue%20spirits%20in%20a%20misty%20night%20forest%2C%20supernatural%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20misty%20night%20forest%20with%20glowing%20spirits%20and%20a%20lone%20figure%2C%20supernatural%20mood%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-06-bd&orientation=landscape",
    summary: "一个能看见亡魂的女孩，一桩跨越生死的旧案。",
    synopsis: "从小能看见亡魂的少女继承了祖母留下的旧宅，却发现这里徘徊着许多未了的心愿。为了帮助这些亡魂，也为了揭开祖母的秘密，她开始走进一个介于生死之间的世界。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20old%20japanese%20house%20at%20night%20with%20paper%20lanterns%20and%20mist%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-16&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shrine%20path%20with%20stacked%20stone%20lanterns%20in%20blue%20twilight%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-17&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20glowing%20fireflies%20over%20a%20quiet%20pond%20at%20night%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-18&orientation=landscape",
    ],
    tags: ["灵异", "治愈", "日剧"],
    updatedAt: "2026-10-08",
  },
  {
    id: "tv-07",
    type: "tv",
    title: "风云九州",
    year: 2025,
    region: "中国",
    genres: ["武侠", "古装"],
    rating: 8.3,
    popularity: 9980,
    director: "顾长风",
    cast: ["霍千山", "慕容雪", "叶无双"],
    duration: "全 52 集",
    cover: "https://readdy.ai/api/search-image?query=a%20martial%20arts%20hero%20standing%20on%20a%20cliff%20overlooking%20misty%20mountains%20at%20sunrise%2C%20wuxia%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20wuxia%20landscape%20of%20misty%20mountains%20and%20ancient%20pagoda%20at%20sunrise%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-07-bd&orientation=landscape",
    summary: "九州烽烟再起，侠者仗剑而行。",
    synopsis: "乱世之中，九州大地群雄并起。一位出身寒门的少年凭借一身武艺与赤诚之心，卷入争夺天下的大局。他在腥风血雨中坚守侠义，书写属于自己的传奇。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20wuxia%20battle%20between%20two%20armies%20on%20a%20vast%20plain%20at%20dawn%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-19&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20ancient%20chinese%20pavilion%20amid%20bamboo%20forest%20in%20soft%20light%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-20&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20a%20swordsman%20training%20under%20a%20waterfall%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-21&orientation=landscape",
    ],
    tags: ["武侠", "热血", "大男主"],
    updatedAt: "2026-10-01",
  },
  {
    id: "tv-08",
    type: "tv",
    title: "家族荣耀",
    year: 2026,
    region: "中国香港",
    genres: ["家族", "剧情"],
    rating: 7.9,
    popularity: 8340,
    director: "麦志远",
    cast: ["何嘉俊", "梁雅雯", "黄国栋", "陈美琪"],
    duration: "全 42 集",
    cover: "https://readdy.ai/api/search-image?query=a%20welldressed%20family%20standing%20in%20a%20grand%20marble%20mansion%20hall%20with%20warm%20light%2C%20prestige%20drama%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20luxury%20mansion%20interior%20hall%20with%20marble%20floors%20and%20chandeliers%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-08-bd&orientation=landscape",
    summary: "豪门风光背后，是一场没有硝烟的争夺。",
    synopsis: "香港老牌企业家族的掌舵人突然病倒，家族成员围绕继承权展开明争暗斗。在利益与亲情的拉扯中，每个人都在为自己的选择付出代价，而被掩埋多年的秘密也逐渐浮出水面。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20boardroom%20meeting%20with%20tense%20family%20members%20around%20a%20long%20table%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-22&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20elegant%20dinner%20party%20in%20a%20luxury%20mansion%20with%20warm%20light%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-23&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20night%20view%20of%20victoria%20harbour%20hong%20kong%20with%20glowing%20skyline%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-24&orientation=landscape",
    ],
    tags: ["豪门", "商战", "港剧"],
    updatedAt: "2026-10-06",
  },
  {
    id: "tv-09",
    type: "tv",
    title: "真相迷局",
    year: 2026,
    region: "韩国",
    genres: ["悬疑", "犯罪"],
    rating: 8.7,
    popularity: 10640,
    director: "金泰勋",
    cast: ["朴尚宇", "韩智恩", "李承珉"],
    duration: "全 20 集",
    cover: "https://readdy.ai/api/search-image?query=a%20detective%20examining%20a%20clue%20board%20with%20red%20strings%20in%20a%20dim%20office%2C%20mystery%20thriller%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20dim%20detective%20office%20with%20clue%20boards%20and%20case%20files%20and%20warm%20lamps%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-09-bd&orientation=landscape",
    summary: "每一个谎言，都是真相的另一块拼图。",
    synopsis: "一桩看似普通的失踪案，让刑警队长卷入了一个错综复杂的迷局。随着调查深入，他发现证人、嫌疑人乃至自己的同僚都在隐瞒秘密。真相就在层层谎言之下，等待被揭开。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20interrogation%20scene%20in%20a%20dim%20room%20with%20two%20figures%20and%20a%20hanging%20lamp%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-25&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20shot%20of%20a%20crime%20scene%20with%20forensic%20investigators%20at%20night%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-26&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20rainy%20seoul%20street%20at%20night%20with%20a%20lone%20detective%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-27&orientation=landscape",
    ],
    tags: ["刑侦", "烧脑", "韩剧"],
    updatedAt: "2026-10-13",
  },
  {
    id: "tv-10",
    type: "tv",
    title: "青春进行时",
    year: 2025,
    region: "中国",
    genres: ["青春", "校园"],
    rating: 7.7,
    popularity: 7120,
    director: "苏念",
    cast: ["许景行", "林晚", "周雨桐"],
    duration: "全 30 集",
    cover: "https://readdy.ai/api/search-image?query=a%20group%20of%20high%20school%20students%20laughing%20on%20a%20sunny%20school%20field%20with%20blue%20sky%2C%20youthful%20cinematic%20lighting%2C%20bright%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20sunny%20high%20school%20campus%20with%20students%20and%20green%20trees%2C%20bright%20cheerful%20mood%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-10-bd&orientation=landscape",
    summary: "那年夏天，我们都在奔跑。",
    synopsis: "一群性格迥异的高中生在紧张的备考生活中，经历了友情、暗恋与梦想的碰撞。他们有过争吵和误会，也有过并肩前行的热血时光，共同书写属于青春的答卷。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20classroom%20scene%20with%20sunlight%20through%20windows%20and%20students%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-28&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20school%20running%20track%20scene%20at%20sunset%20with%20students%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-29&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20rooftop%20scene%20with%20friends%20watching%20the%20city%20at%20dusk%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-30&orientation=landscape",
    ],
    tags: ["校园", "成长", "治愈"],
    updatedAt: "2026-09-29",
  },
  {
    id: "tv-11",
    type: "tv",
    title: "边境线",
    year: 2026,
    region: "中国",
    genres: ["动作", "战争"],
    rating: 8.1,
    popularity: 8940,
    director: "韩致远",
    cast: ["雷云生", "程安", "秦烈"],
    duration: "全 34 集",
    cover: "https://readdy.ai/api/search-image?query=a%20determined%20soldier%20standing%20on%20a%20snowy%20border%20ridge%20at%20dawn%20with%20a%20rifle%2C%20action%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20snowy%20mountain%20border%20at%20dawn%20with%20soldiers%20on%20patrol%2C%20epic%20mood%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-11-bd&orientation=landscape",
    summary: "在祖国最远的边境线上，有一群最可爱的人。",
    synopsis: "一支边防小队驻守在环境恶劣的边境线上，面对风雪、危险与孤独，他们用青春和热血守护着身后的万家灯火。一次次任务与并肩生死，铸就了永不褪色的战友情。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20snowy%20border%20outpost%20with%20soldiers%20and%20warm%20lamps%20at%20night%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-31&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20scene%20of%20soldiers%20sharing%20a%20meal%20in%20a%20tent%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-32&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20mountain%20patrol%20scene%20in%20heavy%20snow%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-33&orientation=landscape",
    ],
    tags: ["军旅", "热血", "家国"],
    updatedAt: "2026-10-10",
  },
  {
    id: "tv-12",
    type: "tv",
    title: "美食人间",
    year: 2025,
    region: "中国",
    genres: ["生活", "治愈"],
    rating: 8.0,
    popularity: 6580,
    director: "何静",
    cast: ["陈美琪", "罗宾·陈", "方小舟"],
    duration: "全 26 集",
    cover: "https://readdy.ai/api/search-image?query=a%20cozy%20small%20restaurant%20at%20dusk%20with%20warm%20glowing%20windows%20and%20steaming%20food%2C%20warm%20cinematic%20lighting%2C%20rich%20color%20grading%2C%20highly%20detailed%20illustration%2C%20drama%20poster%20composition&width=500&height=750&seq=madou-tv-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20night%20food%20street%20with%20glowing%20stalls%20and%20steam%2C%20warm%20inviting%20mood%2C%20rich%20color%20grading%2C%20highly%20detailed%20digital%20painting&width=1600&height=900&seq=madou-tv-12-bd&orientation=landscape",
    summary: "人间烟火气，最抚凡人心。",
    synopsis: "在城市老街的角落里，有一家只在夜晚营业的小餐馆。老板娘用一道道家常菜，温暖着每一位带着故事的食客。食物背后，是平凡生活里最动人的温情。",
    photos: [
      "https://readdy.ai/api/search-image?query=a%20cinematic%20close%20up%20of%20steaming%20homestyle%20dishes%20on%20a%20wooden%20table%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-34&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20cozy%20restaurant%20interior%20with%20warm%20lamps%20and%20diners%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-35&orientation=landscape",
      "https://readdy.ai/api/search-image?query=a%20cinematic%20night%20food%20market%20with%20glowing%20stalls%20and%20chefs%2C%20film%20still%2C%20highly%20detailed&width=800&height=450&seq=madou-tv-still-36&orientation=landscape",
    ],
    tags: ["美食", "治愈", "烟火气"],
    updatedAt: "2026-09-27",
  },
];